// extracted by mini-css-extract-plugin
export default {"container":"OurWork_container__+pT1v","highlight":"OurWork_highlight__GNqTH"};